import { wrapperBuilder } from './build';
import './functions';
import './logic';
import './statics';

export const AnalyticsWrapper = wrapperBuilder.build();
